<template>
  <div>
    <b-modal
      id="show-file-modal-lg"
      v-model="modalState"
      size="lg"
      centered
      :title="$t('userManagement.document')"
      @hide="$emit('update:isShowModal', false)"
    >
      <component
        :is="getUrlTAG()"
        class="w-100"
        style="min-height: 600px"
        :src="url"
        :alt="$t('userManagement.document')"
      />
      <div slot="modal-footer">
        <b-button
          class="mx-1"
          variant="secondary"
          @click="$bvModal.hide('show-file-modal-lg')"
        >
          {{ $t('generals.close') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BImg } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
    BImg,
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalState: false,
    }
  },
  watch: {
    isShowModal(val) {
      console.log('val')
      if (val) this.modalState = true
      else this.modalState = false
    },
  },

  methods: {
    getUrlTAG() {
      const url = this.url.split('.')
      const format = url[url.length - 1]
      const images = ['png', 'jpeg', 'jpg', 'svg']
      if (format && format.toLowerCase() === 'pdf') return 'iframe'
      if (format && images.includes(format.toLowerCase())) return 'b-img'
      return format
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-good-table.scss';
</style>
